import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useSession } from "../auth.jsx";
import { Eyebrow } from "../components/Bits.jsx";

export default function Drift() {
  const s = useSession();
  const [report, setReport] = useState(null);

  useEffect(() => {
    if (!s.profile?.cohortId) return;
    return onSnapshot(doc(db, "drift", s.profile.cohortId), (d) => setReport(d.exists() ? d.data() : null));
  }, [s.profile?.cohortId]);

  return (
    <div>
      <Eyebrow>Faculty calibration</Eyebrow>
      <h1 style={{ fontSize: 24, marginTop: 4 }}>Drift</h1>
      <p style={{ color: "var(--graphite)", maxWidth: "64ch" }}>
        Two signals trigger a recalibration session: a mean more than 0.5 from the cohort, or a variance under
        half the cohort's. The second is the one people miss — a Studio Master who marks everyone the same is
        doing more damage than one who marks hard.
      </p>

      {!report ? (
        <p style={{ marginTop: 16, color: "var(--graphite)" }}>
          No report yet. It is generated every Monday at 06:00 from released marks.
        </p>
      ) : (
        <>
          <p className="mono" style={{ fontSize: 12, marginTop: 12 }}>
            cohort mean {report.cohortStats.mean.toFixed(2)} · variance {report.cohortStats.variance.toFixed(3)} · n {report.cohortStats.n}
          </p>
          <table style={{ marginTop: 10 }}>
            <thead><tr><th>Reviewer</th><th>Marks</th><th>Mean</th><th>Δ cohort</th><th>Variance ratio</th><th></th></tr></thead>
            <tbody>
              {report.rows.map((r) => (
                <tr key={r.reviewerUid}>
                  <td className="mono" style={{ fontSize: 12 }}>{r.reviewerUid.slice(0, 8)}</td>
                  <td>{r.n}</td>
                  <td className="mono">{r.mean.toFixed(2)}</td>
                  <td className={`mono ${Math.abs(r.meanDelta) > 0.5 ? "fail" : ""}`}>{r.meanDelta > 0 ? "+" : ""}{r.meanDelta}</td>
                  <td className={`mono ${r.varianceRatio != null && r.varianceRatio < 0.5 ? "fail" : ""}`}>{r.varianceRatio ?? "—"}</td>
                  <td>{r.recalibrate ? <span className="fail">recalibrate</span> : <span className="pass">in band</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
